import React from 'react';
import { StyleSheet, Text, TouchableHighlight } from 'react-native';
import { PURPLE } from '../constants/Colors';

type Props = { onPress: () => void; title: string };

export default ({ onPress, title }: Props) => {
  return (
    <TouchableHighlight style={styles.container} onPress={onPress}>
      <Text style={styles.title}>{title}</Text>
    </TouchableHighlight>
  );
};

const HEIGHT = 44;
export const TITLE_SIZE = 17;

const styles = StyleSheet.create({
  container: {
    backgroundColor: PURPLE,
    borderRadius: HEIGHT / 2,
    height: HEIGHT,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: { color: 'white', fontSize: TITLE_SIZE },
});
